// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__a1jrc","line1":"Footer_line1__GMsJW","line2":"Footer_line2__LuRJP","link":"Footer_link__aYB2a"};